module.exports = __webpack_public_path__ + "static/car4-f8c487fb4b7b738eb219b48dc146ac6c.png";